const yalda = {
    name: 'Yalda Golsharifi',
    tooltip: 'REVIEW',
    background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/nme%2Fyalda-review.gif?alt=media&token=1f1f3673-2437-4aca-b55e-2708c2cecca8',
    review: "It's amazing how Solarlux connects my interior to my patio. Within 2 years of using SL60, I did not find any fault. It is very easy to operate by using just a gentle push of hand. I’m assured that with proper usage, it can last a lifetime and be passed onto generations.",
};

export default yalda;



// WEBPACK FOOTER //
// ./src/data/review/yalda.js